export const ROUTING_NUMBER_LENGTH = 9;
export const MAX_ACCOUNT_NUMBER_LENGTH = 25;

export const isValidAbaRoutingNumber = (routingNumber: string): boolean => {
  if (!routingNumber || routingNumber.length !== ROUTING_NUMBER_LENGTH) return false;
  const digits = routingNumber.split('').map(Number);
  const checksum = (3 * (digits[0] + digits[3] + digits[6]) +
                   7 * (digits[1] + digits[4] + digits[7]) +
                   (digits[2] + digits[5] + digits[8])) % 10;
  return checksum === 0;
};

export const sanitizeRoutingNumber = (value: string): string => {
  return (value || '').replace(/\D/g, '').substring(0, ROUTING_NUMBER_LENGTH);
};

export const sanitizeAccountNumber = (value: string): string => {
  return (value || '').replace(/\D/g, '').substring(0, MAX_ACCOUNT_NUMBER_LENGTH);
};


